// // import { width } from '@mui/system';
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link, NavLink, useHistory } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";
// import "../Components/Component-css/Header.css";
// import css from "./Component-css/Nav.module.css";
// import { BsPeople } from 'react-icons/bs';
// import BottonMenu from "../uiComponents/BottonMenu";
// import { BsWallet, BsGift } from 'react-icons/bs'
// import { IoMdNotificationsOutline } from "react-icons/io";
// import { FiPlus } from "react-icons/fi";
// import "../Components/Component-css/Header.css";
// import { GiHamburgerMenu } from "react-icons/gi";
// import { LanguageContext } from "./LanguageContext";
// import { useContext } from "react";
// import { useTheme } from "../../ThemeContext";
// import { apiRequest } from "../../apiService/allApi";
// import { FaPlus } from "react-icons/fa";
// import { FaUsers } from "react-icons/fa6";

// const w3_close = () => {
//   const sidebar = document.getElementById("mySidebar");
//   const overlay = document.getElementById("sidebarOverlay");

//   // सुनिश्चित करें कि Sidebar मौजूद है
//   if (sidebar) {
//     // अगर mySidebar मौजूद है, तभी उसकी width पढ़ें
//     const width = sidebar.offsetWidth;
//     sidebar.style.left = `-${width}px`;
//   }

//   // सुनिश्चित करें कि Overlay मौजूद है
//   if (overlay) {
//     overlay.style.display = "none";
//   }
// };

// const w3_open = () => {
//   const sidebar = document.getElementById("mySidebar");
//   const overlay = document.getElementById("sidebarOverlay");

//   // सुनिश्चित करें कि Sidebar और Overlay मौजूद हैं
//   if (sidebar) {
//     sidebar.style.left = "0";
//   }
//   if (overlay) {
//     overlay.style.display = "block";
//   }
// };

// const addsetting = localStorage.getItem("sitSetting");

// const addCaseSetting = JSON.parse(addsetting);
// const udata = localStorage.getItem("udata");
// const profileData = JSON.parse(udata);

// const Header = ({ user }) => {


//   // BASE URL

//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const nodeMode = process.env.NODE_ENV;
//   if (nodeMode === "development") {
//     var baseUrl = beckendLocalApiUrl;
//   } else {
//     baseUrl = beckendLiveApiUrl;
//   }
//   // +++++++++++++++++++++++++++++
//   const [isdropdownVisible, setIsdropdownVisible] = useState(false);

//   const toggleDiv = () => {
//     setIsdropdownVisible(!isdropdownVisible);
//   };

//   const history = useHistory();

//   let access_token = localStorage.getItem("token");
//   access_token = localStorage.getItem("token");

//   const logout = async () => {
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     const respone = await apiRequest(`logout`, "POST", null, headers)

//     localStorage.removeItem("token");
//     window.location.reload();
//     history.push("/");

//   };

//   const [promptInstall, setPromptInstall] = useState(null);
//   const [supportsPWA, setSupportsPWA] = useState(false)


//   useEffect(() => {
//     const handler = e => {
//       e.preventDefault();
//       console.log('beforeinstallprompt event was fired');
//       setPromptInstall(e);
//       setSupportsPWA(true)
//     };

//     window.addEventListener('beforeinstallprompt', handler);

//     return () => window.removeEventListener('beforeinstallprompt', handler);
//   }, []);

//   const onClick = (evt) => {
//     evt.preventDefault();
//     if (!promptInstall) {
//       console.log('No promptInstall event available');
//       return;
//     }
//     promptInstall.prompt();
//     promptInstall.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('User accepted the install prompt');
//       } else {
//         console.log('User dismissed the install prompt');
//       }
//       setPromptInstall(null);
//     });
//   };

//   // language
//   const { changeLanguage } = useContext(LanguageContext);
//   const translations = {
//     hi: {
//       commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
//       profile: "मेरी प्रोफाइल",
//       play: "खेले",
//       wallet: "वॉलेट",
//       refer: "रेफरल और कमाएँ",
//       history: "इतिहास",
//       support: "सहायता",
//       // app: "ऐप डाउनलोड",
//       kyc: "केवाईसी"
//     },
//     en: {
//       commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
//       profile: "My Profile",
//       play: "Play",
//       wallet: "My Wallet",
//       refer: "Refer and Earn",
//       history: "History",
//       support: "Support",
//       // app: " App ",
//       kyc: "KYC",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme 
//   const { theme, toggleTheme } = useTheme("light");
//   const theme1 = localStorage.getItem('theme')

//   const styles = {
//     backgroundColor: theme1 === 'light' ? '#000' : 'black',
//     color: theme1 === 'light' ? '#fff' : '#fff',
//   };
//   const styles1 = {
//     backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
//     color: theme1 === 'light' ? 'black !important' : '#fff !important',

//   };
//   const logo = theme1 === 'light' ? '/mplbets.png' : '/mplbets.png';

//   const colorChange = () => {
//     localStorage.setItem("theme", "#fff")
//     toggleTheme('#fff')
//   }

//   useEffect(() => {
//     localStorage.setItem("theme", "light")

//   }, [])




//   return (
//     <>
//       <div>
//         {access_token ? (
//           <React.Fragment>
//             <div id="sidebarOverlay" onClick={w3_close}></div>
//             <div style={styles}>

//               <div
//                 className="w3-sidebar w3-bar-block"
//                 id="mySidebar"
//                 style={{ paddingBottom: "70px" }}
//               >

//                 <span className=" back_sidebar" onClick={w3_close}><img src="../close.png" /></span>
//                 <Link
//                   to={"/landing"}
//                   className="bg-blue w3-bar-item mt-0 rounded-0 m-0 w-100  sidebar_link "
//                   onClick={w3_close}
//                 >
//                   <picture className="pic-img">
//                     {user && user?.avatar ? (
//                       <img
//                         width="60px"
//                         height="60px"
//                         src={baseUrl + `${user && user?.avatar}`}
//                         alt="profile"
//                         style={{ borderRadius: "50px" }}
//                       />
//                     ) : (
//                       <img src="../mplbets.png" alt="profile" />
//                     )}
//                   </picture>
//                   <h2 class="ml-2 mb-0 text-white typewriter">MPLBETS</h2>
//                 </Link>
//                 <Link
//                   to={"/Profile"}
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={w3_close}
//                 >
//                   <picture className="icon">
//                     {user && user?.avatar ? (
//                       <img
//                         width="30px"
//                         height="30px"
//                         src={baseUrl + `${user && user?.avatar}`}
//                         alt="profile"
//                         style={{ borderRadius: "50px" }}
//                       />
//                     ) : (
//                       <img src="images/icons/sidebar-user.png" alt="profile" />
//                     )}
//                   </picture>
//                   <h3>{translations[language].profile}</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </Link>


//                 <Link
//                   to={"/Homepage/ludoClassicManual"}
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={w3_close}
//                 >
//                   <picture className="icon">
//                     <img
//                       alt="img"
//                       src="/images/icons/play-button.png"
//                       style={{ height: "22px" }}
//                     />
//                   </picture>
//                   <h3>{translations[language].play}</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </Link>
//                 <Link
//                   to={"/wallet"}
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={w3_close}
//                 >
//                   <picture className="icon">
//                     <img alt="img" src="/images/icons/digital-wallet.png" />
//                   </picture>
//                   <h3>{translations[language].wallet}</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </Link>

//                 {addCaseSetting?.isReferral ? (
//                   <>
//                     <Link
//                       to={"/refer"}
//                       className="w3-bar-item w3-button sidebar_link"
//                       onClick={w3_close}
//                     >
//                       <picture className="icon">
//                         <img alt="img" src="/images/icons/refer1.png" />
//                       </picture>
//                       <h3>{translations[language].refer}</h3>
//                       <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                     </Link>
//                   </>
//                 ) : (
//                   ""
//                 )}

//                 <Link
//                   to={"/history"}
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={w3_close}
//                 >
//                   <picture className="icon">
//                     <img alt="img" src="/images/icons/refresh.png" />
//                   </picture>
//                   <h3>{translations[language].history}</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </Link>



//                 <Link
//                   to={"/support"}
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={w3_close}
//                 >
//                   <picture className="icon">
//                     <img alt="img" src="/images/support.jpg" />
//                   </picture>
//                   <h3>{translations[language].support}</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </Link>


//                 {/* <div className="w3-bar-item w3-button sidebar_link ">
//                   <picture className="icon">
//                     <img alt="img" src="../images/icons/translate.png" />
//                   </picture>


//                   <div className="toggle-container">
//                     <button
//                       className={`toggle-button ${language === "en" ? "active" : ""
//                         }`}
//                       onClick={() => changeLanguage("en")}
//                     >
//                       English
//                     </button>
//                     <button
//                       className={`toggle-button ${language === "hi" ? "active" : ""
//                         }`}
//                       onClick={() => changeLanguage("hi")}
//                     >
//                       Hindi
//                     </button>
//                   </div>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </div> */}
//                 <div
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={toggleDiv}
//                 >
//                   <picture className="icon">
//                     <img alt="img" src="/images/icons/insurance.png" />
//                   </picture>
//                   <h3>{isdropdownVisible ? "All Policy" : "All Policy"}</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </div>
//                 {isdropdownVisible && (
//                   <ul className="dropdown_link">
//                     <li>
//                       <Link to="/privacy-policy" onClick={w3_close}>
//                         Privacy Policy
//                       </Link>
//                     </li>
//                     {/* <li>
//                       <Link to="/RefundPolicy" onClick={w3_close}>
//                         Refund/Cancellation Policy
//                       </Link>
//                     </li> */}
//                     <li>
//                       <Link to="/term-condition" onClick={w3_close}>
//                         Terms &amp; Condition
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/tds-policy" onClick={w3_close}>
//                         TDS Policy
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/responsible-gaming" onClick={w3_close}>
//                         Responsible Gaming
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/about" onClick={w3_close}>
//                         About
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/contact-us" onClick={w3_close}>
//                         Contact
//                       </Link>
//                     </li>
//                   </ul>
//                 )}

//                 {/* <div
//                   className="w3-bar-item w3-button sidebar_link"
//                   onClick={w3_close}
//                 >
//                   <picture className="icon style-2">
//                     <img alt="img" src="../images/icons/back.png" />
//                   </picture>
//                   <h3>Back</h3>
//                   <img className="ml-auto" style={{ width: '13px' }} src="/right-arrow.png" />
//                 </div> */}
//               </div>
//             </div>


//             <div className="w3-teal" style={styles}>
//               <div className="w3-container " style={styles}>
//                 <div className={`${css.headerContainer} `} style={styles}>
//                   <button
//                     className=" w3-xlarge float-left menu_button "
//                     onClick={w3_open}
//                     id="hambergar"
//                   >

//                     <img src="/menu.png" />
//                   </button>
//                   <Link to="/">
//                     <img
//                       src={logo}
//                       className="snip-img filter-shadow"
//                       alt="logos"
//                       width="60px"
//                       height="60px"
//                     />
//                   </Link>


//                   <div className="top_menu_bar_main" style={styles}>
//                     <nav className={`${css.menu_items}`}>
//                       <div className="header_navlink_main mr-0">

//                       </div>
//                       <div className="header_navlink_main ml-0">
//                         <NavLink
//                           exact
//                           to="/Addcase"
//                           className="top_menus_link wallet_balance_btn"
//                           activeClassName=""
//                         >
//                           <img
//                             className="header_img_wallet wallet_gif"
//                             src="/images/icons/digital-wallet.png"
//                             alt=""
//                           />
//                           <span>{user && user?.Wallet_balance}</span>
//                         </NavLink>
//                       </div>

//                       <div className="header_navlink_main">
//                         <NavLink
//                           exact
//                           to="/redeem/refer"
//                           className="top_menus_link wallet_balance_btn ml-1 wallet_btn"
//                           activeClassName=""
//                         >
//                           <img
//                             className="header_img_wallet wallet_gif"
//                             onClick={w3_close}
//                             src="/images/referral-bonus.png"
//                             alt=""
//                           />
//                           <span>
//                             {user && user.referral_wallet.toFixed(2)}
//                           </span>
//                         </NavLink>
//                       </div>


//                     </nav>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </React.Fragment>
//         ) : (
//           <div className="w3-teal " style={styles}>
//             <div className="w3-container ">
//               <div className={`${css.headerContainer} justify-content-between`}>
//                 <Link to="/">
//                   <picture className={`ml-2 ${css.navLogo} d-flex`}>
//                     <img
//                       src="/mplbets.png"
//                       className="snip-img"
//                       alt="STARKINGADDA"
//                       width="30px"
//                     />
//                   </picture>
//                 </Link>

//                 <div className={`ml-5`}>
//                   <Link type="button" className="login-btn" to="/login">
//                     LOGIN
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="bottom_menus_main">
//         <BottonMenu w3_close={w3_close} />
//       </div>
//     </>
//   );
// };

// export default Header;


// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from 'react-icons/bs';
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from 'react-icons/bs'
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";

const w3_close = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar मौजूद है
  if (sidebar) {
    // अगर mySidebar मौजूद है, तभी उसकी width पढ़ें
    const width = sidebar.offsetWidth;
    sidebar.style.left = `-${width}px`;
  }

  // सुनिश्चित करें कि Overlay मौजूद है
  if (overlay) {
    overlay.style.display = "none";
  }
};

const w3_open = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar और Overlay मौजूद हैं
  if (sidebar) {
    sidebar.style.left = "0";
  }
  if (overlay) {
    overlay.style.display = "block";
  }
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {


  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(`logout`, "POST", null, headers)

    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");

  };

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false)


  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      console.log('beforeinstallprompt event was fired');
      setPromptInstall(e);
      setSupportsPWA(true)
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log('No promptInstall event available');
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      setPromptInstall(null);
    });
  };

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      kyc: "केवाईसी"
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      support: "Support",
      notify: "Notification",
      // app: " App ",
      kyc: "KYC",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme 
  const { theme, toggleTheme } = useTheme("light");
  const theme1 = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme1 === 'light' ? '#000' : 'black',
    color: theme1 === 'light' ? '#fff' : '#fff',
  };
  const styles1 = {
    backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
    color: theme1 === 'light' ? 'black !important' : '#fff !important',

  };
  const logo = theme1 === 'light' ? '/mplbets.png' : '/mplbets.png';

  const colorChange = () => {
    localStorage.setItem("theme", "#fff")
    toggleTheme('#fff')
  }

  useEffect(() => {
    localStorage.setItem("theme", "light")

  }, [])




  return (
    <>
      <div>
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}></div>

            <div
              className="w3-sidebar w3-bar-block premium-app-sidebar"
              id="mySidebar"
            >
              {/* Decorative Background */}
              <div className="sidebar-bg-shape sidebar-shape-one"></div>
              <div className="sidebar-bg-shape sidebar-shape-two"></div>

              {/* =========================
      SIDEBAR HEADER
  ========================== */}
              <div className="premium-sidebar-header">
                <Link
                  to="/landing"
                  className="premium-sidebar-brand"
                  onClick={w3_close}
                >
                  <div className="premium-sidebar-logo">
                    {user && user?.avatar ? (
                      <img
                        src={baseUrl + `${user?.avatar}`}
                        alt="profile"
                      />
                    ) : (
                      <img src="/mplbets.png" alt="Apna Addaa" />
                    )}
                  </div>

                  <div className="premium-brand-info">
                    <strong>MPLBETS</strong>
                    <span>Play • Win • Enjoy</span>
                  </div>
                </Link>

                <button
                  type="button"
                  className="premium-sidebar-close"
                  onClick={w3_close}
                  aria-label="Close sidebar"
                >
                  <span></span>
                  <span></span>
                </button>
              </div>


              {/* =========================
      SIDEBAR CONTENT
  ========================== */}
              <div className="premium-sidebar-content">

                {/* MY PROFILE */}
                <Link
                  to="/Profile"
                  className="premium-menu-card menu-profile"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon icon-purple">
                    {user && user?.avatar ? (
                      <img
                        src={baseUrl + `${user?.avatar}`}
                        alt="profile"
                      />
                    ) : (
                      <span className="sidebar-emoji">👤</span>
                    )}
                  </div>

                  <div className="premium-menu-text">
                    <h3>{translations[language].profile}</h3>
                    <p>View and manage profile</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>


                {/* PLAY */}
                <Link
                  to="/Homepage/ludoClassicManual"
                  className="premium-menu-card"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon icon-violet">
                    <span className="sidebar-emoji">🎮</span>
                  </div>

                  <div className="premium-menu-text">
                    <h3>Play Zone</h3>
                    <p>Start playing now</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>


                {/* WALLET */}
                <Link
                  to="/wallet"
                  className="premium-menu-card"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon icon-pink">
                    <span className="sidebar-emoji">🏦</span>
                  </div>

                  <div className="premium-menu-text">
                    <h3>Withdraw Money</h3>
                    <p>Transfer your winnings</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>


                {/* REFERRAL - ORIGINAL CONDITION PRESERVED */}
                {addCaseSetting?.isReferral ? (
                  <Link
                    to="/redeem/refer"
                    className="premium-menu-card"
                    onClick={w3_close}
                  >
                    <div className="premium-menu-icon icon-orange">
                      <span className="sidebar-emoji">🎁</span>
                    </div>

                    <div className="premium-menu-text">
                      <h3>Refer Cash</h3>
                      <p>Earn referral bonus</p>
                    </div>

                    <span className="premium-menu-arrow">›</span>
                  </Link>
                ) : (
                  ""
                )}


                {/* INVITE & EARN */}
                <Link
                  to="/refer"
                  className="premium-menu-card"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon icon-blue">
                    <span className="sidebar-emoji">🚀</span>
                  </div>

                  <div className="premium-menu-text">
                    <h3>Invite & Earn</h3>
                    <p>Invite friends & win</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>
                


                {/* HISTORY */}
                <Link
                  to="/history"
                  className="premium-menu-card"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon icon-magenta">
                    <span className="sidebar-emoji">📜</span>
                  </div>

                  <div className="premium-menu-text">
                    <h3>{translations[language].history}</h3>
                    <p>View all matches</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>


                {/* SUPPORT - DARK PREMIUM CARD */}
                <Link
                  to="/support"
                  className="premium-menu-card premium-support-card"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon support-icon-box">
                    <span className="sidebar-emoji">🎧</span>
                    <span className="support-online-dot"></span>
                  </div>

                  <div className="premium-menu-text">
                    <h3>{translations[language].support}</h3>
                    <p>We are here to help</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>


                {/* NOTIFICATION */}
                <Link
                  to="/Notification"
                  className="premium-menu-card"
                  onClick={w3_close}
                >
                  <div className="premium-menu-icon icon-yellow">
                    <span className="sidebar-emoji">🔔</span>
                  </div>

                  <div className="premium-menu-text">
                    <h3>{translations[language].notify}</h3>
                    <p>Check latest updates</p>
                  </div>

                  <span className="premium-menu-arrow">›</span>
                </Link>





                {/* =========================
        INSTALL APP
        ORIGINAL PWA FUNCTION
    ========================== */}
                {supportsPWA && (
                  <button
                    type="button"
                    className="premium-install-app"
                    onClick={onClick}
                  >
                    <span className="install-app-shine"></span>

                    <span className="install-download-icon">
                      ↓
                    </span>

                    <span>Install App</span>
                  </button>
                )}


                {/* FOOTER */}
                <div className="premium-sidebar-footer">
                  <div className="secure-indicator">
                    <span></span>
                    Secure Gaming Platform
                  </div>

                  <p>Play responsibly • 18+</p>
                </div>

              </div>
            </div>


            <div className="w3-teal" style={styles}>
              <div className="w3-container " style={styles}>
                <div className={`${css.headerContainer} `} style={styles}>
                  <button
                    className=" w3-xlarge float-left menu_button "
                    onClick={w3_open}
                    id="hambergar"
                  >

                    <img src="/menu.png" />
                  </button>
                  <Link to="/">
                    <img
                      src={logo}
                      className="snip-img filter-shadow"
                      alt="logos"
                      width="50px"
                      height="40px"
                    />
                  </Link>


                  <div className="top_menu_bar_main" style={styles}>
                    <nav className={`${css.menu_items}`}>
                      <div className="header_navlink_main mr-0">

                      </div>
                      <div className="header_navlink_main ml-0">

                        <NavLink
                          exact
                          to="/Addcase"
                          className="top_menus_link wallet_balance_btn"
                          activeClassName=""
                        >

                          <img class="header_img_wallet" src="/images/moneyrupee.png" />
                          <span> {user && user?.Wallet_balance}</span>

                        </NavLink>
                        
                      </div>

                      <div className="header_navlink_main">

                        <NavLink
                          exact
                          to="/redeem/refer"
                          className="top_menus_link wallet_balance_btn ml-1 wallet_btn"
                          activeClassName=""
                        >
                          <img class="header_img_wallet" onClick={w3_close} src="/images/monney.png" />
                          {/* <FaUsers className=' wallet-dark'  /> */}

                          <span>
                            {user && user.referral_wallet.toFixed(2)
                            }
                          </span>
                        </NavLink>
                      </div>


                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="/mplbets.png"
                      className="snip-img"
                      alt="STARKINGADDA"
                      width="30px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;
